import type { ButtonHTMLAttributes } from "react";
import { Volume2 } from "lucide-react";

import { mergeClassNames } from "./classNames";
import "./controls.css";

export interface AudioReplayButtonProps
  extends Omit<
    ButtonHTMLAttributes<HTMLButtonElement>,
    "aria-label" | "children"
  > {
  label?: string;
  isPlaying?: boolean;
  playingLabel?: string;
}

export function AudioReplayButton({
  label = "再听一遍",
  isPlaying = false,
  playingLabel = "正在播放",
  className,
  type = "button",
  ...buttonProps
}: AudioReplayButtonProps) {
  const visibleLabel = isPlaying ? playingLabel : label;

  return (
    <button
      {...buttonProps}
      aria-busy={isPlaying || undefined}
      aria-label={visibleLabel}
      className={mergeClassNames("ui-audio-replay", className)}
      data-playing={isPlaying}
      type={type}
    >
      <Volume2 aria-hidden="true" className="ui-audio-replay__icon" />
      <span aria-live="polite" className="ui-audio-replay__label">
        {visibleLabel}
      </span>
    </button>
  );
}
